module.exports = __webpack_public_path__ + "img/wallet_icon.2b138dbd.svg";